<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5 d-flex" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia"> </template>
            <template v-else>
              <h4>Componentes Curriculares:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" ref="observer">
      <form @submit.prevent="onFormSubmit" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="mb-4">
                <e-label>
                  Etapas
                  <e-chips-extensao-etapa :etapa="etapaSelecionada" />
                </e-label>
              </div>

              <e-autocomplete
                v-if="editing"
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
                class="mt-2"
              />

              <e-autocomplete
                v-else
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
                class="mt-2"
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none mt-8"
              @click="() => criarPedido(etapaSelecionada.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false && etapaPendente == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                  class="mt-2"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                    <e-label>Selecione uma data</e-label>
                    <v-text-field
                      v-model="aulaSelecionada.data"
                      persistent-hint
                      :disabled="!aulaSelecionada.tipo_de_aula"
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </template>

                <v-card>
                  <v-container class="calendar-container-vertical">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="pa-3 calendar-card-expanded" elevation="2" outlined>
                          <v-date-picker
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            :events="[
                              ...feriados.map((f) => f.data),
                              ...diasLetivos.map((l) => l.data),
                              ...diasNaoLetivos.map((d) => d.data),
                            ]"
                            :event-color="getEventColor"
                            @update:picker-date="atualizarMesVisivel"
                            color="primary"
                            header-color="primary"
                            class="expanded-date-picker"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge
                                :color="getBadgeColor(date)"
                                :content="getBadgeContent(date)"
                                overlap
                                dot
                              >
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-card class="events-card-below" elevation="2" outlined>
                          <v-card-title class="primary white--text pa-3">
                            <v-icon left color="white">mdi-calendar-month</v-icon>
                            Eventos do Mês
                          </v-card-title>
                          <v-divider></v-divider>

                          <v-list dense class="py-0 event-list-expanded">
                            <template v-for="(evento, index) in eventosFiltradosPorMes">
                              <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                              <v-list-item class="px-3" :key="`evento-${index}`">
                                <v-list-item-icon class="mr-2">
                                  <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="d-flex align-center flex-wrap">
                                    <span class="date-label mr-2">{{
                                      formatarDia(evento.data)
                                    }}</span>
                                    <span class="event-description">
                                      {{ evento.descricao }}
                                      <v-chip
                                        v-if="evento.is_sabado_letivo"
                                        x-small
                                        color="green"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia Letivo
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        x-small
                                        color="red"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia não letivo
                                      </v-chip>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>

                            <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                              <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text">
                                  Nenhum evento neste mês
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions class="dialog-actions">
                    <v-btn text color="primary" @click="modal = false"> Cancelar </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)"> OK </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col cols="12">
              <!-- Esse bloco comentado foi utilizado para permitir a escolha das disciplinas, porém o protocolo
               #6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA solicita sua REMOÇÃO PROVISÓRIA - pode ser descomentado quando for necessário a
               seleção de mais de uma disciplina -->

              <!--
               <div cols="12" v-if="!editing">
                <div v-if="gestaoDeAula.is_polivalencia">
                  <e-label>Selecione as Disciplinas dessa Aula:</e-label>
                  <div class="container">
                    <div class="row">
                      <v-checkbox
                        class="ml-2"
                        v-for="(item, index) in gestaoDeAula.disciplinas"
                        :key="index"
                        v-model="disciplinasMarcadas"
                        :label="item.descricao"
                        :value="item.id"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              FIM -->

              <!-- Bloco adicionado para realizar a solitação do protocolo "#6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA"
                Pode ser removido quando for necessário escolher mais de uma disciplina -->

              <div cols="12" v-if="!editing && gestaoDeAula.is_polivalencia">
                <e-label>Selecione o componente curricular dessa Aula:</e-label>

                <v-radio-group v-model="disciplinaSelecionada" @change="onDisciplinaSelecionada">
                  <v-radio
                    v-for="(item, index) in gestaoDeAula.disciplinas"
                    :key="index"
                    :label="item.descricao"
                    :value="item.id"
                  />
                </v-radio-group>
              </div>

              <!-- Fim -->

              <v-col cols="12" v-else>
                <div v-if="aulaSelecionada.disciplinas?.length">
                  <div class="row mb-2">
                    <e-label>Componentes Curriculares dessa Aula</e-label>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div v-for="(item, index) in aulaSelecionada.disciplinas" :key="index">
                        <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- <v-col class="pt-4 pb-0 d-flex align-center" cols="12" v-if="horarioSelecionado.length > 1 && !editing">
                <e-label class="mt-">Replicar Conteúdo </e-label>
                <e-help-tooltip class="ml-2 mt-5" :text="$constants.tooltips.aulas.replicarAula" />
                <v-switch v-model="aulaSelecionada.replicar_conteudo" hide-details class="mt-2 mb-4 ml-4"></v-switch>
              </v-col> -->

              <template v-if="!gestaoDeAula.is_polivalencia">
                <!-- <e-label>Conteúdo</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.conteudo"
                  :error-messages="errors"
                /> -->
              </template>

              <template v-else>
                <!-- <e-label>Conteúdos</e-label> -->
                <div v-if="!editing">
                  <v-card v-for="item in arrayConteudos" :key="item.id" class="mx-auto my-1 col-12">
                    <strong>Horário de {{ item.descricao }}: </strong>
                    <e-help-tooltip :text="$constants.tooltips.aulas.horarios" />
                    <ValidationProvider name="horario" rules="required" v-slot="{ errors }">
                      <!-- Esse bloco comentado foi utilizado para permitir a escolha de multiplos horários, porém o protocolo
                      #6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA solicita sua REMOÇÃO PROVISÓRIA -
                      pode ser descomentado quando for necessário a seleção de mais de um horário -->
                      <!-- <e-autocomplete
                        :disabled="aulaSelecionada.data ? false : true"
                        :items="getFilteredHorariosByDiscipline(item.id)"
                        multiple
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarios_selecionados_extras[item.id]"
                        return-object
                        dense
                        @change="
                          ($event) => {
                            verifyHorariosSelectExtra($event, item.id, $event);
                          }
                        "
                        :error-messages="errors"
                      /> -->

                      <!-- Bloco adicionado para permitir a escolha de apenas um horário referente ao protocolo "#6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA" -->
                      <e-autocomplete
                        :disabled="aulaSelecionada.data ? false : true"
                        :items="getFilteredHorariosByDiscipline(item.id)"
                        v-model="horarios_selecionados_extras[item.id]"
                        label="Selecione um ou mais horários"
                        :item-text="(item) => item.descricao"
                        return-object
                        multiple
                        chips
                        dense
                        @change="onHorarioSelecionado(item.id, $event)"
                        :error-messages="errors"
                      />
                      <!-- Fim -->
                    </ValidationProvider>

                    <v-col
                      class="pt-4 pb-0 d-flex align-center"
                      cols="12"
                      v-if="horarioSelecionado.length > 1 && !editing"
                    >
                      <e-label class="mt-">Replicar Conteúdo </e-label>
                      <e-help-tooltip
                        class="ml-2 mt-5"
                        :text="$constants.tooltips.aulas.replicarAula"
                      />
                      <v-switch
                        v-model="aulaSelecionada.replicar_conteudo"
                        hide-details
                        class="mt-2 mb-4 ml-4"
                      ></v-switch>
                    </v-col>

                    <v-divider class="mt-5 mb-8"></v-divider>

                    <div class="mb-5">
                      <span
                        >Conteúdos de: <strong>{{ item.descricao }}</strong>
                      </span>
                    </div>

                    <v-tabs
                      v-if="horarioSelecionado.length > 1 && !aulaSelecionada.replicar_conteudo"
                      v-model="activeTab"
                      background-color="transparent"
                      color="primary"
                      grow
                      class="mt-4"
                    >
                      <v-tab v-for="h in horarioSelecionado" :key="h.id">
                        {{ h.descricao }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items
                      v-model="activeTab"
                      v-if="horarioSelecionado.length > 1 && !aulaSelecionada.replicar_conteudo"
                    >
                      <v-tab-item eager v-for="h in horariosComDados" :key="h.id">
                        <div class="pa-4">
                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'unidades_tematicas_' + h.id + '_' + item.id"
                              name="Unidades temáticas"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium">Unidades temáticas:</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].unidades_tematicas[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].unidades_tematicas[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'objetos_conhecimento_' + h.id + '_' + item.id"
                              name="Objetos do conhecimento"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium">Objetos do conhecimento:</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].objetos_conhecimento[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].objetos_conhecimento[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'habilidades_' + h.id + '_' + item.id"
                              name="Habilidades"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium">Habilidades:</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].habilidades_texto[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].habilidades_texto[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'objetivos_aprendizagem_' + h.id + '_' + item.id"
                              name="Objetivo de Aprendizagem"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium"
                                >Objetivo de Aprendizagem:</e-label
                              >
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].objetivos_aprendizagem[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].objetivos_aprendizagem[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'procedimentos_metodologicos_' + h.id + '_' + item.id"
                              name="Procedimentos Metodológicos"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium"
                                >Procedimentos Metodológicos:</e-label
                              >
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].procedimentos_metodologicos[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].procedimentos_metodologicos[item.id] || "")
                                      .length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'materiais_apoio_' + h.id + '_' + item.id"
                              name="Material de Apoio"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium">Material de Apoio:</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].materiais_apoio[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].materiais_apoio[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>

                          <div class="mt-2">
                            <ValidationProvider
                              :vid="'avaliacoes_aula_' + h.id + '_' + item.id"
                              name="Avaliação da Aula"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <e-label class="font-weight-medium">Avaliação da Aula:</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="dadosAulas[h.id].avaliacoes_aula[item.id]"
                                :maxlength="4000"
                                :counter="true"
                                :error-messages="errors"
                              >
                                <template v-slot:counter>
                                  {{
                                    (dadosAulas[h.id].avaliacoes_aula[item.id] || "").length
                                  }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </div>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>

                    <div v-else>
                      <div class="mt-2">
                        <ValidationProvider
                          name="Unidades temáticas"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Unidades temáticas:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="unidades_tematicas[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (unidades_tematicas[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider
                          name="Objetos do conhecimento"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Objetos do conhecimento:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="objetos_conhecimento[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (objetos_conhecimento[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
                          <e-label class="font-weight-medium">Habilidades:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="habilidades_texto[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (habilidades_texto[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider
                          name="Objetivo de Aprendizagem"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Objetivo de Aprendizagem:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="objetivos_aprendizagem[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (objetivos_aprendizagem[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider
                          name="Procedimentos Metodológicos"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Procedimentos Metodológicos:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="procedimentos_metodologicos[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (procedimentos_metodologicos[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider
                          name="Material de Apoio"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Material de Apoio:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="materiais_apoio[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (materiais_apoio[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>

                      <div class="mt-2">
                        <ValidationProvider
                          name="Avaliação da Aula"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-label class="font-weight-medium">Avaliação da Aula:</e-label>
                          <v-textarea
                            solo
                            dense
                            v-model="avaliacoes_aula[item.id]"
                            :maxlength="4000"
                            :counter="true"
                            :error-messages="errors"
                          >
                            <template v-slot:counter>
                              {{ (avaliacoes_aula[item.id] || "").length }}/4000
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                    </div>
                  </v-card>
                </div>
                <div v-else-if="editing">
                  <v-card
                    v-for="(item, index) in arrayConteudos"
                    :key="index"
                    class="mx-auto my-1 col-12"
                  >
                    <strong>{{ getNomeDisciplina(item.id) }}</strong>
                    <!-- <div class="mt-8">
                          <e-label class="font-weight-medium">Conteúdo:</e-label>
                          <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].content"
                          :maxlength="4000"
                          :counter="true"
                          >
                          <template v-slot:counter>
                          {{ (arrayConteudos[index].content || "").length }}/4000
                          </template>
                          </v-textarea>
                          </div> -->

                    <div class="mt-2">
                      <ValidationProvider
                        name="Unidades temáticas"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Unidades temáticas:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].unidades_tematicas"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].unidades_tematicas || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider
                        name="Objetos do conhecimento"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Objetos do conhecimento:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].objetos_conhecimento"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].objetos_conhecimento || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
                        <e-label class="font-weight-medium">Habilidades:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].habilidades"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].habilidades || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider
                        name="Objetivo de Aprendizagem"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Objetivo de Aprendizagem:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].objetivo"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].objetivo || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider
                        name="Procedimentos Metodológicos"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Procedimentos Metodológicos:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].procedimento"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].procedimento || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider
                        name="Material de Apoio"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Material de Apoio:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].material"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].material || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div class="mt-2">
                      <ValidationProvider
                        name="Avaliação da Aula"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label class="font-weight-medium">Avaliação da Aula:</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="arrayConteudos[index].avaliacao"
                          :maxlength="4000"
                          :counter="true"
                          :error-messages="errors"
                        >
                          <template v-slot:counter>
                            {{ (arrayConteudos[index].avaliacao || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </div>

                    <div>
                      <div class="mb-5">
                        <ul v-if="horariosDefinidos?.find((x) => x?.id === item?.id)?.array">
                          <div
                            v-for="(item, ind) in horariosDefinidos?.find((x) => x?.id === item?.id)
                              ?.array"
                            :key="ind"
                          >
                            <li>{{ getObjHorario(item) }}</li>
                          </div>
                        </ul>
                        <v-btn @click="editarHorario = index">Alterar Horário</v-btn>
                      </div>
                    </div>

                    <template v-if="editarHorario === index">
                      <ValidationProvider name="horario" rules="required" v-slot="{ errors }">
                        <!-- Esse bloco comentado foi utilizado para permitir a escolha de multiplos horários, porém o protocolo
                          #6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA solicita sua REMOÇÃO PROVISÓRIA -
                          pode ser descomentado quando for necessário a seleção de mais de um horário -->

                        <!-- <e-autocomplete
                          :disabled="aulaSelecionada.data ? false : true"
                          :items="getFilteredHorariosByDiscipline(item.id)"
                          multiple
                          label="Selecione"
                          :item-text="(item) => item.descricao"
                          v-model="horarios_selecionados_extras[item.id]"
                          return-object
                          dense
                          @change="
                            ($event) => {
                              verifyHorariosSelectExtra($event, item.id, $event);
                            }
                          "
                          :error-messages="errors"
                          /> -->

                        <!-- Bloco adicionado para permitir a escolha de apenas um horário referente ao protocolo "#6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA" -->
                        <e-autocomplete
                          :disabled="aulaSelecionada.data ? false : true"
                          :items="getFilteredHorariosByDiscipline(item.id)"
                          v-model="horarios_selecionados_extras[item.id]"
                          label="Selecione um horário"
                          :item-text="(item) => item.descricao"
                          return-object
                          dense
                          @change="onHorarioSelecionado(item.id, $event)"
                          :error-messages="errors"
                        />
                        <!-- Fim -->
                      </ValidationProvider>
                    </template>
                  </v-card>
                </div>
              </template>

              <v-btn
                color="primary"
                :disabled="submittingForm || desabilitarCampos"
                :loading="submittingForm"
                @click="tipoEnvio = 'salvar'"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-tooltip v-if="!editing" :disabled="!aulaEmDataFutura()" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-inline-block" v-bind="attrs" v-on="on">
                    <v-btn
                      color="primary"
                      class="ml-3"
                      :disabled="submittingForm || aulaEmDataFutura()"
                      :loading="submittingForm"
                      @click="tipoEnvio = 'frequencia'"
                      type="submit"
                      >Enviar Dados e Lançar Frequência</v-btn
                    >
                  </div>
                </template>
                <span>
                  Esta frequência só poderá ser lançada na mesma data ou superior em que a aula foi
                  criada
                </span>
              </v-tooltip>
              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.duplicar = true"
                >Duplicar Aula</v-btn
              >
              <v-btn
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção essa etapa está bloqueada, para lançar aulas você deve solicitar uma
              autorização, clicando no botão acima
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaPendente == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Aguarde, já existe um pedido de autorização para essa etapa e estamos analisando.
            </v-alert>
            <v-btn class="success" @click="verPedidos">Acompanhe seus pedidos</v-btn>
          </v-col>
        </v-row>

        <div
          v-if="
            etapas?.length > 0 &&
            etapaBloqueada == false &&
            etapaSelecionada &&
            etapaPendente == false
          "
        >
          <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data">
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable persistent>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <!-- <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
                Fechar
              </v-btn> -->

          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>
          <h2 class="mt-4">Aulas conflitadas</h2>
          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Componente Curricular</th>
                </tr>
              </thead>
              <tr>
                <td>{{ aula_id ?? "- - -" }}</td>
                <td>
                  {{ instrutorConflito ?? "- - -" }}
                  <br />
                  <v-chip color="grey" dark x-small>
                    {{ franquiaConflito ?? "- - -" }}
                  </v-chip>
                </td>
                <td>{{ aulaConflitoSituacao ? aulaConflitoSituacao : "Aguardando" }}</td>
                <td>
                  <span>
                    {{ data?.split("-").reverse().join("/") }}
                  </span>
                  <span> - {{ horarioComConflito ?? "- - -" }} </span>
                  <!-- <span v-if="horarios_extras"> - {{ item?.horarios_extras ?? "" }} </span> -->
                </td>
                <td>{{ turmaComConflito ?? "- - -" }}</td>

                <td>{{ disciplinaComConflito ?? "- - -" }}</td>
              </tr>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >
    <e-modal-duplicar-aula-polivalencia
      v-if="aulaSelecionada.disciplinas"
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      :disciplinas="aulaSelecionada.disciplinas"
      :gestaoDeAulaCompleta="gestaoDeAula"
      :todosEventos="todosEventos"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula-polivalencia>
    <e-modal-duplicar-aula
      v-else
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <!-- <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula> -->
    <e-modal-exportar-aula-polivalencia
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula-polivalencia>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    horariosComDados() {
      return this.horarioSelecionado.filter((h) => this.dadosAulas && this.dadosAulas[h.id]);
    },
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      return (this.todosEventos || [])
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
    disciplinasComHorarioParaData() {
      if (!this.gestaoDeAula?.disciplinas || !this.aulaSelecionada.data) {
        return [];
      }
      return this.gestaoDeAula.disciplinas.filter((disciplina) => {
        const horarios = this.getFilteredHorariosByDiscipline(disciplina.id);
        return horarios && horarios.length > 0;
      });
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
    this.carregarFeriados();
  },
  data() {
    return {
      desabilitarCampos: false,
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      arrayIdsHorarios: [],
      horarioComConflito: null,
      disciplinaComConflito: null,
      checkHorarioExtra: [],
      array_horarios_extras: [],
      horarios_selecionados_extras: [],
      conteudos: [],
      objetivos_aprendizagem: [],
      procedimentos_metodologicos: [],
      materiais_apoio: [],
      avaliacoes_aula: [],
      unidades_tematicas: [],
      objetos_conhecimento: [],
      habilidades_texto: [],
      horarios_selecionados: [],
      arrayConteudos: [],
      text: "",
      textColor: "#000000",
      disciplinasMarcadas: [],
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      autorizacao: [],
      mostrarEtapas: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
      data: null,
      modal: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: false,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      aulaSelecionada: {
        data: null,
        objetivo_de_aprendizagem: null,
        procedimentos_metodologicos: null,
        material_de_apoio: null,
        // avaliacao_da_aula: null,
        unidades_tematicas: null,
        objeto_conhecimento: null,
        habilidades: null,
        replicar_conteudo: true,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: [],
      arrayConteudoEditar: [],
      arrayHorarios: [],
      arrayHorariosEditar: [],
      editarHorario: null,
      horariosAll: [],
      horariosDefinidos: [],
      arrayHorariosMarcados: [],
      mesVisivel: null,
      todosEventos: [],
      feriados: [],
      eventos: [],
      sabadosLetivos: [],
      diasLetivos: [],
      diasNaoLetivos: [],
      turmaComConflito: null,
      franquiaConflito: null,
      instrutorConflito: null,
      aulaConflitoSituacao: null,
      disciplinaSelecionada: null,
      dadosAulas: {},
      tipoEnvio: "salvar",
      activeTab: 0,
    };
  },
  watch: {
    horarioSelecionado(newVal) {
      if (!this.editing) {
        if (!newVal || newVal.length === 0) {
          this.dadosAulas = {};
          this.unidades_tematicas = [];
          this.objetos_conhecimento = [];
          this.habilidades_texto = [];
          this.objetivos_aprendizagem = [];
          this.procedimentos_metodologicos = [];
          this.materiais_apoio = [];
          this.aulaSelecionada.avaliacao_da_aula = "";
        } else if (this.dadosAulas) {
          const selectedIds = newVal.map((h) => h.id);
          Object.keys(this.dadosAulas).forEach((id) => {
            if (!selectedIds.includes(parseInt(id, 10))) {
              this.$delete(this.dadosAulas, id);
            }
          });
        }
      }

      if (newVal && newVal.length > 0) {
        newVal.forEach((h) => {
          if (!this.dadosAulas[h.id]) {
            this.$set(this.dadosAulas, h.id, {
              unidades_tematicas: {},
              objetos_conhecimento: {},
              habilidades_texto: {},
              objetivos_aprendizagem: {},
              procedimentos_metodologicos: {},
              materiais_apoio: {},
              avaliacoes_aula: {},
              conteudos: {},
            });

            // Pré-preenche com os valores atuais da disciplina se existirem
            if (this.disciplinaSelecionada) {
              const dId = this.disciplinaSelecionada;
              this.$set(
                this.dadosAulas[h.id].unidades_tematicas,
                dId,
                this.unidades_tematicas[dId] || ""
              );
              this.$set(
                this.dadosAulas[h.id].objetos_conhecimento,
                dId,
                this.objetos_conhecimento[dId] || ""
              );
              this.$set(
                this.dadosAulas[h.id].habilidades_texto,
                dId,
                this.habilidades_texto[dId] || ""
              );
              this.$set(
                this.dadosAulas[h.id].objetivos_aprendizagem,
                dId,
                this.objetivos_aprendizagem[dId] || ""
              );
              this.$set(
                this.dadosAulas[h.id].procedimentos_metodologicos,
                dId,
                this.procedimentos_metodologicos[dId] || ""
              );
              this.$set(
                this.dadosAulas[h.id].materiais_apoio,
                dId,
                this.materiais_apoio[dId] || ""
              );
            }
          }
        });
      }
    },
    disciplinasMarcadas(val) {
      const arrayConvert = [];
      val.forEach((element) => {
        const valor = this.gestaoDeAula.disciplinas.filter((dado) => dado.id === element);
        arrayConvert.push(valor[0]);
      });
      this.atualizarTopicos(arrayConvert);
    },
    "aulaSelecionada.replicar_conteudo": function () {
      if (!this.editing) {
        this.unidades_tematicas = [];
        this.objetos_conhecimento = [];
        this.habilidades_texto = [];
        this.objetivos_aprendizagem = [];
        this.procedimentos_metodologicos = [];
        this.materiais_apoio = [];
        this.avaliacoes_aula = [];
        this.aulaSelecionada.avaliacao_da_aula = "";

        const newDadosAulas = {};
        if (!this.aulaSelecionada.replicar_conteudo && this.horarioSelecionado?.length > 0) {
          this.horarioSelecionado.forEach((h) => {
            newDadosAulas[h.id] = {
              unidades_tematicas: {},
              objetos_conhecimento: {},
              habilidades_texto: {},
              objetivos_aprendizagem: {},
              procedimentos_metodologicos: {},
              materiais_apoio: {},
              avaliacoes_aula: {},
              conteudos: {},
            };

            let ids = [];
            if (this.disciplinasMarcadas?.length > 0) {
              ids = this.disciplinasMarcadas;
            } else if (this.disciplinaSelecionada) {
              ids = [this.disciplinaSelecionada];
            } else {
              ids = [];
            }

            ids.forEach((dId) => {
              newDadosAulas[h.id].unidades_tematicas[dId] = "";
              newDadosAulas[h.id].objetos_conhecimento[dId] = "";
              newDadosAulas[h.id].habilidades_texto[dId] = "";
              newDadosAulas[h.id].objetivos_aprendizagem[dId] = "";
              newDadosAulas[h.id].procedimentos_metodologicos[dId] = "";
              newDadosAulas[h.id].materiais_apoio[dId] = "";
              newDadosAulas[h.id].avaliacoes_aula[dId] = "";
            });
          });
        }
        this.dadosAulas = newDadosAulas;
      }
    },

    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
        this.mostrarCampos = true;
        this.outrosCampos = true;
      } else if (this.aulaSelecionada.tipo_de_aula) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      } else {
        this.mostrarCampos = false;
        this.outrosCampos = false;
      }
    },
    data(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay(), value);
    },
  },
  methods: {
    aulaEmDataFutura() {
      return this.$ehAulaFutura(this.aulaSelecionada.data);
    },
    // Faz JSON.parse com fallback seguro. Se o valor for texto puro (não JSON), retorna [valor].
    parseJsonArray(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [value];
      }
    },
    // Bloco adicionado para realizar a solitação do protocolo "#6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA" - Pode ser removido quando for necessário escolher mais de um horário
    onHorarioSelecionado(disciplinaId, values) {
      const schedules = [].concat(values || []).filter(Boolean);

      // remove registro anterior da disciplina
      this.array_horarios_extras = this.array_horarios_extras.filter((h) => h.id !== disciplinaId);

      const scheduleIds = schedules.map((s) => s.id);

      if (scheduleIds.length > 0) {
        this.array_horarios_extras.push({
          id: disciplinaId,
          array: scheduleIds,
        });
      }

      // Sincroniza horarioSelecionado (que é usado para as abas)
      this.horarioSelecionado = schedules;

      scheduleIds.forEach((id) => {
        this.pesquisaAulas(id, disciplinaId);
      });
    },
    // FIM

    /* Bloco adicionado para realizar a solitação do protocolo "#6894 [QTP] - IMPEDIR SELEÇÃO DE MAIS DE UM HORÁRIO/DISCIPLINA POR AULA"
    Pode ser removido quando for necessário escolher mais de uma disciplina */

    onDisciplinaSelecionada(id) {
      this.disciplinasMarcadas = [id]; // mantém backend compatível

      const disciplina = this.gestaoDeAula.disciplinas.find((d) => d.id === id);

      if (!disciplina) return;

      // Isso é o que FAZ conteúdo e horário aparecerem
      this.arrayConteudos = [disciplina];

      // limpa horários anteriores
      this.horarios_selecionados_extras = [];
      this.horarioSelecionado = [];
      this.array_horarios_extras = [];
      this.dadosAulas = {};
      this.unidades_tematicas = [];
      this.objetos_conhecimento = [];
      this.habilidades_texto = [];
      this.objetivos_aprendizagem = [];
      this.procedimentos_metodologicos = [];
      this.materiais_apoio = [];
      this.aulaSelecionada.avaliacao_da_aula = "";
    },

    /* FIM */

    toYMD(v) {
      if (!v) return "";

      if (typeof v === "string") {
        if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
          return v.slice(0, 10);
        }

        const parts = v.split("/");
        if (parts.length === 3) {
          const [dia, mes, ano] = parts;
          return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }

        if (v.length > 10) return v.slice(0, 10);
      }

      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },
    getFilteredHorariosByDiscipline(disciplineId) {
      if (!this.aulaSelecionada.data || !this.gestaoDeAula?.relacoesDiasHorarios) {
        return [];
      }

      const diaDaSemana = new Date(this.toYMD(this.aulaSelecionada.data)).getDay();
      const dataFormatada = this.toYMD(this.aulaSelecionada.data);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);

      if (evento && (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)) {
        return this.todosHorariosDisponiveis || [];
      }

      const filteredRelations = this.gestaoDeAula.relacoesDiasHorarios.filter((r) => {
        const match = r.dia.id === diaDaSemana && r.disciplina.id === disciplineId;
        return match;
      });

      const horariosFiltrados = filteredRelations.map((r) => r.horario);

      return horariosFiltrados;
    },
    allowedDates(val) {
      let dataFormatada;
      if (typeof val === "string") {
        dataFormatada = val.length > 10 ? val.slice(0, 10) : val;
      } else {
        dataFormatada = new Date(val).toISOString().split("T")[0];
      }

      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === dataFormatada;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return true;
        }
        return false;
      }
      const ehFeriado = this.feriados.some((feriado) => {
        const fData = feriado.data.length > 10 ? feriado.data.slice(0, 10) : feriado.data;
        return fData === dataFormatada;
      });
      if (ehFeriado) return true;

      const diaDaSemana = new Date(dataFormatada).getDay();
      if (!this.diasPermitidosParaCriarAula.includes(diaDaSemana)) return false;

      return true;
    },
    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao || "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana, dataSelecionada = this.data) {
      const dataFormatada = this.toYMD(dataSelecionada);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);

      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
            await this.buscarTodosHorarios();
          }

          this.horarios = this.todosHorariosDisponiveis || [];
          this.horariosDoComponente = this.todosHorariosDisponiveis.map((h) => ({
            id: h.id,
            descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
            inicio: h.inicio,
            final: h.final,
            turno_id: h.turno_id,
          }));
          return;
        }

        if (evento.is_letivo === true || evento.is_letivo === 1) {
          const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
            .filter((r) => r.dia.id === diaDaSemana)
            .map((r) => r.horario);
          this.horarios = horariosDoDia;
          this.horariosDoComponente = horariosDoDia;
          return;
        }
        if (!this.editing) {
          this.horarios = [];
          this.horariosDoComponente = [];
        }
        return;
      }

      if (!this.gestaoDeAula?.relacoesDiasHorarios) {
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((r) => r.dia.id === diaDaSemana)
        .map((r) => r.horario);

      this.horarios = horariosDoDia;
      this.horariosDoComponente = horariosDoDia;
    },
    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();
        this.todosEventos = response.map((evento) => ({
          data: evento.start.length > 10 ? evento.start.slice(0, 10) : evento.start,
          descricao: evento.descricao,
          cor: evento.color,
          is_feriado: evento.evento.is_feriado,
          is_sabado_letivo: evento.evento.is_sabado_letivo,
          is_letivo: evento.evento.is_letivo,
        }));
        this.feriados = this.todosEventos.filter((evento) => evento.is_feriado === true);
        this.sabadosLetivos = this.todosEventos.filter(
          (evento) => evento.is_sabado_letivo === true
        );
        this.diasLetivos = this.todosEventos.filter(
          (ev) =>
            ev.is_sabado_letivo === true ||
            ev.is_sabado_letivo === 1 ||
            ev.is_letivo === true ||
            ev.is_letivo === 1
        );
        this.diasNaoLetivos = this.todosEventos.filter(
          (ev) => !ev.is_sabado_letivo && !ev.is_letivo && !ev.is_feriado
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },
    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    getEventColor(date) {
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) return feriado.cor || "red";
      const letivo = this.diasLetivos.find((l) => l.data === date);
      if (letivo) return letivo.cor || "green";
      const bloqueio = this.diasNaoLetivos && this.diasNaoLetivos.find((d) => d.data === date);
      if (bloqueio) return bloqueio.cor || "red";
      return "primary";
    },
    getHorariosDaAula(aula) {
      const horariosFiltrados = [];

      const horariosDaAulaExtra = JSON.parse(aula?.horarios_extras);

      return horariosDaAulaExtra;
    },

    valoresComuns(array1, array2) {
      return array1.filter((valor) => array2.includes(valor));
    },
    verifyHorariosSelectExtra(item, IDdisciplina, $event) {
      let disciplina = this.array_horarios_extras.find((it) => it.id === IDdisciplina);

      if (!disciplina) {
        disciplina = {
          id: IDdisciplina,
          array: [],
        };
        this.array_horarios_extras.push(disciplina);
      } else {
        disciplina.array = [];
      }

      const horariosDosOutrosCampos = this.array_horarios_extras
        .filter((it) => it.id !== IDdisciplina)
        .flatMap((it) => it.array);

      item.forEach((element) => {
        if (horariosDosOutrosCampos.includes(element.id)) {
          this.$toast.warn("Esse horário está sendo usado, escolha outro!");

          if (this.horarios_selecionados_extras[IDdisciplina]) {
            this.horarios_selecionados_extras[IDdisciplina] = this.horarios_selecionados_extras[
              IDdisciplina
            ].filter((it) => it.id !== element.id);
          }
        } else {
          disciplina.array.push(element.id);
          this.pesquisaAulas(element.id, IDdisciplina);
        }
      });
    },

    removerValorDoArray(valor) {
      let horarios = this.horarios;
      horarios = horarios.filter((item) => item.id !== valor.id);
    },

    getNomeDisciplina(id) {
      const dis = this.gestaoDeAula.disciplinas.filter((obj) => obj.id === id);
      return dis[0].descricao;
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0]?.descricao || "Horário não encontrado";
      }
    },
    editarConteudoPoli(index, $event) {
      this.arrayConteudos[index] = $event;
    },
    editarHorarioPoli(index, $event) {
      this.arrayHorarios[index] = $event;
    },
    getConteudoPolivalencia() {
      if (!this.aulaSelecionada.disciplinas || !Array.isArray(this.aulaSelecionada.disciplinas)) {
        this.arrayConteudoEditar = [];
        return;
      }

      const safeParse = (val) => {
        if (!val) return [];
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [val];
        } catch (e) {
          return [val];
        }
      };

      const avaliacaoPolivalencia = safeParse(this.aulaSelecionada.avaliacao_da_aula);
      const conteudoPolivalencia = safeParse(this.aulaSelecionada.conteudo_polivalencia);
      const objetivoPolivalencia = safeParse(this.aulaSelecionada.objetivo_de_aprendizagem);
      const procedimentoPolivalencia = safeParse(this.aulaSelecionada.procedimentos_metodologicos);
      const materialPolivalencia = safeParse(this.aulaSelecionada.material_de_apoio);
      const unidadesPolivalencia = safeParse(this.aulaSelecionada.unidades_tematicas);
      const objetosPolivalencia = safeParse(this.aulaSelecionada.objeto_conhecimento);
      const habilidadesPolivalencia = safeParse(this.aulaSelecionada.habilidades);

      this.aulaSelecionada.disciplinas.forEach((element, index) => {
        const obj = {
          id: element,
          content: conteudoPolivalencia[index] || "",
          objetivo: objetivoPolivalencia[index] || "",
          procedimento: procedimentoPolivalencia[index] || "",
          material: materialPolivalencia[index] || "",
          avaliacao: avaliacaoPolivalencia[index] || "",
          unidades_tematicas: unidadesPolivalencia[index] || "",
          objetos_conhecimento: objetosPolivalencia[index] || "",
          habilidades: habilidadesPolivalencia[index] || "",
        };
        this.arrayConteudos.push(obj);
      });
    },
    getHorariosPolivalencia(id) {
      return this.horarios.filter((item) => item.id === id);
    },
    atualizarTopicos(array) {
      this.arrayConteudos = [];
      array.forEach((element) => {
        this.arrayConteudos.push(element);
      });
    },
    updateText(event) {
      this.text = event.target.innerHTML;
    },
    executeCommand(command) {
      document.execCommand(command, false, null);
    },

    changeFont(size) {
      document.execCommand("fontSize", false, "7");
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontSize = size;
        range.surroundContents(node);
      }
    },
    changeStyle(style) {
      document.execCommand(style, false, null);
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontStyle = style === "italic" ? style : null;
        node.style.fontWeight = style === "bold" ? style : null;
        node.style.textDecoration = style === "underline" ? style : null;
        range.surroundContents(node);
      }
    },
    setTextColor() {
      this.executeCommand("foreColor", this.textColor);
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.aulaSelecionada.data = null;
      this.horariosDefinidos = null;
      // this.horarios = null;
      // this.array_horarios_extras = null;

      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada.id).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },

    async pesquisaAulas(horarioId, disciplinaId) {
      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      // /* eslint-disable */
      const { aula_id } = this.$route.params;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !horarioId || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
        data_aula,
        horarioId,
        turma_id,
        aula_id
      );

      if (response.data.conflito) {
        const conflito = response.data.aulas[0];
        const aulaConflito = conflito.aula;
        const instrutorConflito = conflito.instrutor;
        const franquiaConflito = conflito.franquia;
        const aulaConflitoSituacao = conflito.situacao;
        const aula_id = conflito.id;
        const turmaComConflito = conflito.turma;
        const disciplinaNome = conflito.disciplina_descricao;
        const horarioConflito = conflito.horario;

        // this.horarioComConflito = this.horarios.find((item) => item.id === horarioId);

        this.aula_id = aula_id;
        this.franquiaConflito = instrutorConflito;
        this.instrutorConflito = instrutorConflito;
        this.aulaConflitoSituacao = aulaConflitoSituacao;
        this.disciplinaComConflito = disciplinaNome;
        this.turmaComConflito = turmaComConflito;
        this.horarioComConflito = horarioConflito;

        this.aulasEmConflitos = true;
        this.desabilitarCampos = true;
      }

      this.desabilitarCampos = false;
    },

    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async editarHorarioIndividual(index, obj) {
      const horariosAula = JSON.parse(this.aulaSelecionada?.horarios);
      horariosAula[index] = obj.id;
      this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
      this.aulaSelecionada.horarios = JSON.stringify(horariosAula);

      await this.$services.aulasService.atualizar(this.aulaSelecionada);
      this.$toast.success("Horário editado com sucesso!");
      this.loadData();
      this.editarHorario = null;
    },
    async onFormSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.submitForm();
      } else {
        const errors = this.$refs.observer.errors;
        const vidsWithErrors = Object.keys(errors).filter((vid) => errors[vid].length > 0);

        if (vidsWithErrors.length > 0) {
          // Busca o primeiro VID que tenha o padrão de ID de horário (ex: _IDHORARIO_IDDISCIPLINA)
          const firstVidWithHorario = vidsWithErrors.find((vid) => /_(\d+)(?:_\d+)?$/.test(vid));

          if (firstVidWithHorario) {
            const match = firstVidWithHorario.match(/_(\d+)(?:_\d+)?$/);
            if (match) {
              const horarioId = parseInt(match[1], 10);
              const index = this.horariosComDados.findIndex((h) => h.id === horarioId);
              if (index !== -1) {
                this.activeTab = index;
              }
            }
          }
        }
      }
    },
    async submitForm() {
      const payload = { ...this.aulaSelecionada };

      if (this.editing) {
        // conteudos
        const arrayParaEditar = [];
        const objetivosParaEditar = [];
        const procedimentosParaEditar = [];
        const materiaisParaEditar = [];
        const avaliacoesParaEditar = [];
        const unidadesParaEditar = [];
        const objetosParaEditar = [];
        const habilidadesParaEditar = [];

        this.arrayConteudos.forEach((element) => {
          arrayParaEditar.push(element.content);
          objetivosParaEditar.push(element.objetivo);
          procedimentosParaEditar.push(element.procedimento);
          materiaisParaEditar.push(element.material);
          avaliacoesParaEditar.push(element.avaliacao);
          unidadesParaEditar.push(element.unidades_tematicas);
          objetosParaEditar.push(element.objetos_conhecimento);
          habilidadesParaEditar.push(element.habilidades);
        });

        payload.conteudo_polivalencia = JSON.stringify(arrayParaEditar);
        payload.objetivo_de_aprendizagem = JSON.stringify(objetivosParaEditar);
        payload.procedimentos_metodologicos = JSON.stringify(procedimentosParaEditar);
        payload.material_de_apoio = JSON.stringify(materiaisParaEditar);
        payload.avaliacao_da_aula = JSON.stringify(avaliacoesParaEditar);
        payload.unidades_tematicas = JSON.stringify(unidadesParaEditar);
        payload.objeto_conhecimento = JSON.stringify(objetosParaEditar);
        payload.habilidades = JSON.stringify(habilidadesParaEditar);

        payload.horarios_extras = JSON.stringify(this.array_horarios_extras);
      } else {
        payload.horarios = this.horarioSelecionado.map((h) => {
          const useRootState =
            this.aulaSelecionada.replicar_conteudo || this.horarioSelecionado.length === 1;
          const dadosH = useRootState ? this : this.dadosAulas[h.id];

          const arr_unidades = [];
          const arr_objetos = [];
          const arr_habilidades = [];
          const arr_objetivos = [];
          const arr_procedimentos = [];
          const arr_materiais = [];
          const arr_avaliacoes = [];

          this.disciplinasMarcadas.forEach((dId) => {
            arr_unidades.push(dadosH.unidades_tematicas[dId]);
            arr_objetos.push(dadosH.objetos_conhecimento[dId]);
            arr_habilidades.push(dadosH.habilidades_texto[dId]);
            arr_objetivos.push(dadosH.objetivos_aprendizagem[dId]);
            arr_procedimentos.push(dadosH.procedimentos_metodologicos[dId]);
            arr_materiais.push(dadosH.materiais_apoio[dId]);
            arr_avaliacoes.push(dadosH.avaliacoes_aula[dId]);
          });

          return {
            id: h.id,
            inicio: h.inicio,
            final: h.final,
            unidades_tematicas: JSON.stringify(arr_unidades),
            objeto_conhecimento: JSON.stringify(arr_objetos),
            habilidades: JSON.stringify(arr_habilidades),
            objetivo_de_aprendizagem: JSON.stringify(arr_objetivos),
            procedimentos_metodologicos: JSON.stringify(arr_procedimentos),
            material_de_apoio: JSON.stringify(arr_materiais),
            avaliacao_da_aula: JSON.stringify(arr_avaliacoes),
            disciplinas: this.disciplinasMarcadas,
            horarios_extras: JSON.stringify([{ id: this.disciplinaSelecionada, array: [h.id] }]),
          };
        });

        payload.disciplinas = this.disciplinasMarcadas;
        payload.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
        payload.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
      }

      payload.horario_inicial =
        this.horarioSelecionado.length > 0 ? this.horarioSelecionado[0].inicio : null;
      payload.horario_final =
        this.horarioSelecionado.length > 0 ? this.horarioSelecionado[0].final : null;
      payload.horario_id =
        this.horarioSelecionado.length > 0 ? this.horarioSelecionado[0].id : null;
      payload.etapa_id = this.etapaSelecionada.id;

      this.submittingForm = true;
      try {
        if (this.editing) {
          payload.instrutorDisciplinaTurma_id = parseInt(this.$route.params.gestaoDeAulaId, 10);
          payload.data = payload.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(payload);
          this.$toast.success("Aula editada com sucesso!");
          this.$router.back();
        } else {
          payload.instrutorDisciplinaTurma_id = parseInt(this.$route.params.gestaoDeAulaId, 10);
          payload.disciplina_id = this.gestaoDeAula.disciplina_id;
          payload.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          payload.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          payload.data = payload.data.split("/").reverse().join("-");

          const response = await this.$services.aulasService.criar(payload);

          if (this.tipoEnvio === "frequencia") {
            const aulas = Array.isArray(response) ? response : [response];
            const ids = aulas.map((a) => a.id).join(",");
            this.$toast.success("Aula(s) salva(s). Redirecionando para frequência...");
            this.$router.push({
              name: "aulas.frequencia-lote",
              params: {
                gestaoDeAulaId: this.$route.params.gestaoDeAulaId,
                aula_ids: ids,
              },
            });
          } else {
            this.$toast.success("Aula cadastrada com sucesso!");
            this.$router.back();
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );

      this.turma = response.payload.gestaoDeAula.turma;
      this.gestaoDeAula = response.payload.gestaoDeAula;

      await this.buscarTodosHorarios();

      this.horarios = response.payload.horarios.filter((horario) => {
        if (this.gestaoDeAula.is_polivalencia) {
          return horario.descricao;
        }
        return horario.descricao;
      });

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
      this.horarioSelecionado = aulaSelecionada.horario ? [aulaSelecionada.horario] : [];

      this.text = aulaSelecionada.conteudo;
      this.aulaSelecionada.data = aulaSelecionada.data;
      this.data = aulaSelecionada.data;
      const diaSemana = new Date(this.data).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);

        this.horariosSabado = this.horarios;
        this.horariosSabado = this.horariosSabado.map((h) => {
          return {
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
            final: h.final,
            inicio: h.inicio,
          };
        });
        this.horariosDoComponente =
          new Date(this.data).getDay() === 5 ? this.horariosSabado : this.horarios;
      }
      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.buscarTodosHorarios();
        this.aulaSelecionada = await this.getAula();

        if (!this.aulaSelecionada.disciplinas) {
          this.aulaSelecionada.disciplinas = [];
        }

        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId,
            "aulas"
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
            this.horariosDefinidos = this.getHorariosDaAula(this.aulaSelecionada);
          }
          if (this.aulaSelecionada.disciplinas && this.gestaoDeAula.disciplinas) {
            this.$set(
              this.aulaSelecionada,
              "disciplinas_com_descricao",
              this.aulaSelecionada.disciplinas
                .map((id) => this.gestaoDeAula.disciplinas.find((d) => d.id === id))
                .filter(Boolean)
            );

            // Adicionar esta lógica para filtrar horarios_extras
            if (this.aulaSelecionada.horarios_extras) {
              try {
                let horariosExtrasParsed = JSON.parse(this.aulaSelecionada.horarios_extras);
                const idsDisciplinasValidas = this.aulaSelecionada.disciplinas_com_descricao.map(
                  (d) => d.id
                );
                horariosExtrasParsed = horariosExtrasParsed.filter((he) =>
                  idsDisciplinasValidas.includes(he.id)
                );
                this.aulaSelecionada.horarios_extras = JSON.stringify(horariosExtrasParsed);
              } catch (e) {
                // console.error("Erro ao processar horarios_extras:", e);
              }
            }
          }
        }
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.$forceUpdate();

        if (this.editing) {
          this.getConteudoPolivalencia();
          this.getHorariosPolivalencia();
          this.array_horarios_extras = JSON.parse(this.aulaSelecionada.horarios_extras);
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(etapaId);

      if (response.data.aprovados?.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes?.length) {
        this.idsEtapasPendentes.push(etapaId);
      }
    },
    beforeDestroy() {
      this.text = this.$refs.editor.innerHTML;
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },
    isDiaLetivo(date) {
      return this.diasLetivos.some((l) => l.data === date);
    },
    isDiaNaoLetivo(date) {
      return this.diasNaoLetivos && this.diasNaoLetivos.some((d) => d.data === date);
    },
    getBadgeColor(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        return (
          evento.cor ||
          (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1 ? "green" : "red")
        );
      }

      if (this.isFeriado(date)) return "red";
      return "";
    },
    getBadgeContent(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return "Letivo";
        }
        return "Dia não letivo";
      }
      if (this.isFeriado(date)) return "F";
      return "";
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}

.events-card {
  margin-top: 20px;
}

.calendar-container-vertical {
  max-width: 100%;
  padding: 0;
}

.calendar-card-expanded {
  margin-bottom: 20px;
}

.expanded-date-picker {
  width: 100%;
}

.events-card-below {
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
}

.event-list-expanded {
  max-height: 250px;
  overflow-y: auto;
}

.date-label {
  min-width: 30px;
  font-weight: bold;
}

.event-description {
  word-break: break-word;
}

.dialog-actions {
  padding: 16px;
  justify-content: flex-end;
}

/* Ajustes responsivos */
@media (max-width: 960px) {
  .calendar-container-vertical {
    flex-direction: column;
  }

  .calendar-card-expanded,
  .events-card-below {
    max-width: 100%;
  }

  .events-card-below {
    max-height: 250px;
  }
}
</style>
